import Sell from './sell.js';
import Home from './home.js';
import Buy from './buy.js';
import About from './about.js';
import Recycle from './recycle.js';
import React from 'react';

import './App.css';


class Pages extends React.Component {
    constructor(props) {
        super(props);
        this.state = {


            page: <Home />
        };
        ;

    }
    handleHome = () => {
        this.setState({ page: <Home /> });
    }

    handleBuy = () => {
        this.setState({ page: <Buy /> });
    }

    handleSell = () => {
        this.setState({ page: <Sell /> });
    }

    handleAbout = () => {
        this.setState({ page: <About /> });
    }
    handleRecycle = () => {
        this.setState({ page: <Recycle /> });
    }

    render() {


        return (
            <div >
                <div class="topnav">
                    <a href={this.handleHome} onClick={this.handleHome}>Home</a>
                    <a href={this.handleBuy} onClick={this.handleBuy} style={{ backgroundColor: "turquoise", borderBlockStyle: "ridge", }}>Buy</a>
                    <a href={this.handleSell} onClick={this.handleSell} style={{ backgroundColor: "orange", borderBlockStyle: "ridge", }}>Sell</a>
                    <a href={this.handleRecycle} onClick={this.handleRecycle}>Recycling tips and locations</a>
                    <a href={this.handleAbout} onClick={this.handleAbout}>About</a>





                </div>
                <div className=" container">

                    {this.state.page}

                </div>
            </div>
        );
    }
}



export default Pages;
